import React from 'react'
import HubspotForm from 'react-hubspot-form'
import { CircularProgress, Paper, Typography } from '@mui/material'
import PageDescriptionComponent from '../HelpfulGuides/PageDescriptionComponent'

interface IHubspotFormProps {
  classes?: any
}
interface IHubspotFormState {
  hubspotReady: boolean
}

class HubspotSupportForm extends React.Component<
  IHubspotFormProps,
  IHubspotFormState
> {
  placeholder: any
  constructor(props: IHubspotFormProps) {
    super(props)
    this.state = {
      hubspotReady: false,
    }
  }

  render() {
    return (
      <>
        <PageDescriptionComponent
          textContent={
            <>
              <Typography variant={'h6'} gutterBottom={true} align={'center'}>
                <b>Pledre support form</b>
              </Typography>
              <Typography
                variant={'body2'}
                gutterBottom={true}
                align={'center'}
              >
                Do you have any challenges, questions, requests or inquires? Let
                us know.
                <br />
                Kindly fill the form below.
                <br />
                You can also send a mail to{' '}
                <a href={'mailto:support@pledre.com'}>support@pledre.com</a>
              </Typography>
            </>
          }
        />

        <Paper style={{ padding: '50px 20px' }}>
          <HubspotForm
            portalId="5826839"
            formId="53bab20a-41ae-44b0-9e7d-38dc7d81e2c9"
            onSubmit={() => console.log('Submit!')}
            onReady={(_form: any) => console.log('Form ready!')}
            loading={
              <div style={{ width: '100%', textAlign: 'center' }}>
                <CircularProgress
                  color="primary"
                  style={{ margin: 'auto' }}
                  size={20}
                />
              </div>
            }
          />
        </Paper>
      </>
    )
  }
}

export default HubspotSupportForm
